var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-card-container',{class:[
    'ar-message-list-card-skeleton',
    _vm.showAs ]},[_c('div',{staticClass:"description-section"},[_c('am2-typography-skeleton',{style:({
        maxWidth: '150px',
      }),attrs:{"size":"sm","level":_vm.level + 2}}),_vm._v(" "),_c('am2-typography-skeleton',{staticClass:"u-margin-top-2",style:({
        maxWidth: '250px',
      }),attrs:{"size":"xs","level":_vm.level + 2}})],1),_vm._v(" "),_c('div',{staticClass:"stats-section"})])}
var staticRenderFns = []

export { render, staticRenderFns }